import { MAILTO } from "@/lib/mailto";

export default function Nav() {
  return (
    <header
      data-testid="site-nav"
      className="nav-border sticky top-0 z-40 bg-sand/90 backdrop-blur-sm"
    >
      <div className="mx-auto flex max-w-[1100px] items-center justify-between px-6 py-5 md:px-10">
        <a
          href="#top"
          data-testid="nav-brand"
          className="font-display text-deep-lake"
          style={{ fontWeight: 500, fontSize: "20px", letterSpacing: "-0.01em" }}
        >
          Kat Ryder Consulting
        </a>

        <a
          href={MAILTO}
          data-testid="nav-cta-get-in-touch"
          className="btn-primary btn-small"
          aria-label="Get in touch by email"
        >
          Get in touch
        </a>
      </div>
    </header>
  );
}
